import * as yup from "yup";

const ServiceSchema = yup.object({
    nameUA: yup.string().required("Це поле обов'язкове"),
    descriptionUA: yup.string().required("Це поле обов'язкове"),
    nameEN: yup.string().required("This field is required"),
    descriptionEN: yup.string().required("This field is required"),
    miniature: yup.string().url("Це повинно бути посилання").required("Це поле обов'язкове"),
    gps: yup.string().matches(/^\d+.\d+, \d+.\d+$/, "Неправильний формат координат").required("Це поле обов'язкове"),
    categories: yup.string().required("Це поле обов'язкове"),
}).required();

export default ServiceSchema;